var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 11.25H26.25M8.75 3.75V6.25M21.25 3.75V6.25M7.5 16.25H10M7.5 21.25H10M13.75 16.25H16.25M13.75 21.25H16.25M20 16.25H22.5M20 21.25H22.5M7.75 26.25H22.25C23.6501 26.25 24.3502 26.25 24.885 25.9775C25.3554 25.7378 25.7378 25.3554 25.9775 24.885C26.25 24.3502 26.25 23.6501 26.25 22.25V10.25C26.25 8.84987 26.25 8.1498 25.9775 7.61502C25.7378 7.14462 25.3554 6.76217 24.885 6.52248C24.3502 6.25 23.6501 6.25 22.25 6.25H7.75C6.34987 6.25 5.6498 6.25 5.11502 6.52248C4.64462 6.76217 4.26217 7.14462 4.02248 7.61502C3.75 8.1498 3.75 8.84987 3.75 10.25V22.25C3.75 23.6501 3.75 24.3502 4.02248 24.885C4.26217 25.3554 4.64462 25.7378 5.11502 25.9775C5.6498 26.25 6.34987 26.25 7.75 26.25Z",
    stroke: "#FFFCF8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingsIcon);
export default __webpack_public_path__ + "static/media/bookings_icon.fa86761193985f60019c701f9cb14df7.svg";
export { ForwardRef as ReactComponent };